import React, {Component, Fragment} from 'react';
import {Button, Card, CardBody, CardTitle, Row} from 'reactstrap';
import {withTranslation} from 'react-i18next';
import {NotificationManager} from '../../../../components/common/react-notifications';
import TradeFeePolicyLevels from '../../../../containers/TradeFeePolicyLevels';
import TradeFeePolicyForm from '../../../../containers/TradeFeePolicyForm';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {reactTableText} from '../../../../constants/configs';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import ModalManager from '../../../../components/modal/ModalManager';
import ToolTip from '../../../../components/ToolTip';
import Rbac from '../../../../components/Rbac';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      policies: [],
      expanded: {},
      loading: true,
    };
  }

  fetchPolicies = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/loyalty-policies', null, {
        params: {limit: 100}
      });
      this.setState({
        policies: data.policies,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({loading: false});
    }
  };

  deletePolicy = async id => {
    const {t} = this.props;
    try {
      await Api.invoke(
        'DELETE',
        '/admin-ui/loyalty-policies',
        null,
        {params: {id}}
      );
      NotificationManager.success(t('Trade fee policy deleted successfully'), t('Message'));
      this.table.fireFetchData();
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onPressDelete = id => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Confirm Delete'),
      body: t('Are you sure you want to delete this trade fee policy ?'),
      buttons: [
        {
          color: 'primary',
          onClick: () => {
            this.deletePolicy(id);
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Accept'),
        },
        {
          color: 'grey',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Close'),
        },
      ],
    });
  };

  onPressCreate = () => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Create Trade Fee Policy'),
      body: <TradeFeePolicyForm fireFetchData={() => {this.table.fireFetchData();}}/>
    });
  };

  onPressEdit = policy => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit Trade Fee Policy'),
      body: <TradeFeePolicyForm policy={policy} fireFetchData={() => {this.table.fireFetchData();}}/>
    });
  };

  onExpanded = (newExpanded, index) => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index[0]]: !!newExpanded[index[0]],
      },
    });
  };

  showLevels = index => {
    this.setState({
      expanded: {
        ...this.state.expanded,
        [index]: true,
      },
    });
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'name',
    },
    {
      Header: t('Actions'),
      accessor: 'id',
      width: Rbac.hasPermission('update_policies') ? 120 : 60,
      Cell: props => <div className='d-flex flex-row align-items-center justify-content-between px-2'>
        <ToolTip id={`show_${props.value}`} text={t('Show Levels')}>
          <span className="text-one" onClick={() => {this.showLevels(props.index);}}>
            <i className="simple-icon-eye view-icon cursor-pointer"/>
          </span>
        </ToolTip>
        <Rbac permission="update_policies">
          <ToolTip id={`edit_${props.value}`} text={t('Edit')}>
            <span className="text-one text-primary" onClick={() => {this.onPressEdit(props.original);}}>
              <i className="simple-icon-pencil edit-icon cursor-pointer"/>
            </span>
          </ToolTip>
        </Rbac>
        <Rbac permission="delete_policies">
          <ToolTip id={`delete_${props.value}`} text={t('Delete')}>
            <span className="text-one text-danger" onClick={() => {this.onPressDelete(props.value);}}>
              <i className="simple-icon-trash delete-icon cursor-pointer"/>
            </span>
          </ToolTip>
        </Rbac>
      </div>,
    },
  ];

  render() {
    const {t, match} = this.props;
    const {policies, expanded, loading} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary d-flex flex-row justify-content-between align-items-center">
                  {t('Policies List')}
                  <Rbac permission='create_policies'>
                    <Button onClick={this.onPressCreate}>
                      <i className="simple-icon-plus add-reply-icon"/>
                      <span className="mx-1">{t('Add')}</span>
                    </Button>
                  </Rbac>
                </CardTitle>
                <ReactTable
                  manual
                  className="-highlight"
                  ref={el => {this.table = el;}}
                  data={policies}
                  loading={loading}
                  sortable={false}
                  resizable={true}
                  showPagination={false}
                  expanded={expanded}
                  onFetchData={this.fetchPolicies}
                  columns={this.getColumns(t)}
                  onExpandedChange={this.onExpanded}
                  pageSize={policies.length || 3}
                  style={{width: '100%'}}
                  {...reactTableText}
                  SubComponent={row => {
                    const {original} = row;
                    return (
                      <TradeFeePolicyLevels policy={original} fireFetchData={() => {this.table.fireFetchData();}}/>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(List);
